import { render } from "./ServicesEditor.vue?vue&type=template&id=bac54fde&scoped=true"
import script from "./ServicesEditor.vue?vue&type=script&lang=js"
export * from "./ServicesEditor.vue?vue&type=script&lang=js"

import "./ServicesEditor.vue?vue&type=style&index=0&id=bac54fde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac54fde"]])

export default __exports__